import React, { useEffect } from 'react';
import { toast } from 'react-toastify';
import { SideBarDeleteActionWithPopup } from '../../../../components/commons/SideBarComponents/DeleteActionWithPopup/sideBarDeleteActionWithPopup';
import {
  StyledContainerItems,
  StyledContainerFooterSideBar,
  StyledTitleSideBar
} from '../../../../components/commons/SideBarComponents/sideBarComponentsStyles';
import Strings from '../../../../i18n';
import { SideBarSimpleMethodItem } from '../../../../components/commons/SideBarComponents/SimpleMethodItem/sideBarSimpleMethodButtonItem';
import { ISequence } from '../../../../types/sequences/sequencesInterface';
import {
  useDeleteLightShowMutation,
  useExecuteLightShowMutation,
  useResaveSequenceMutation
} from '../../../../services/sequences/sequencesService';

interface ISceneDetailsProps {
  lightShow: ISequence;
  selectedLightShows: ISequence[];
  setSelectedLightShows: (scenes: ISequence[]) => void;
  openSideBar: boolean;
  setOpenSideBar: (openSideBar: boolean) => void;
  reloadTable: () => void;
}
export const LightShowsDetails = ({
  lightShow,
  openSideBar,
  selectedLightShows,
  setSelectedLightShows,
  setOpenSideBar,
  reloadTable
}: ISceneDetailsProps) => {
  const [execute, { isSuccess: isSuccessExecute }] =
    useExecuteLightShowMutation();

  const [deleteLs, { isSuccess: isSuccessDelete }] =
    useDeleteLightShowMutation();

  const [resaveSequence, { isSuccess: isSuccessResave }] =
    useResaveSequenceMutation();

  const resaveLightShow = () => {
    resaveSequence(lightShow.id);
  };

  const executeLightShow = () => {
    execute(lightShow.id);
  };

  const deleteScene = () => {
    deleteLs(lightShow.id);
  };

  useEffect(() => {
    if (isSuccessExecute) {
      setOpenSideBar(false);
      setSelectedLightShows([]);
      toast.success(Strings.scenes.successExecuteScene);
    }
  }, [isSuccessExecute]);

  useEffect(() => {
    if (isSuccessResave) {
      setOpenSideBar(false);
      setSelectedLightShows([]);
      toast.success(Strings.scenes.successResaveLightShow);
    }
  }, [isSuccessResave]);

  useEffect(() => {
    if (isSuccessDelete) {
      setOpenSideBar(false);
      setSelectedLightShows([]);
      toast.success(Strings.scenes.successDeleteScene);
      reloadTable();
    }
  }, [isSuccessDelete]);

  return (
    <>
      {lightShow && (
        <>
          <StyledContainerItems>
            <StyledTitleSideBar>{lightShow?.name}</StyledTitleSideBar>
            <SideBarSimpleMethodItem
              name={Strings.lightShows.executeLightShow}
              action={() => executeLightShow()}
              successAction={false}
              textSuccess="success"
            />
            <SideBarSimpleMethodItem
              name={Strings.lightShows.resaveLightShow}
              action={() => resaveLightShow()}
              successAction={false}
              textSuccess="success"
            />
            <SideBarDeleteActionWithPopup
              onDelete={() => deleteScene()}
              titleConfirmation={Strings.lightShows.deleteLightShow}
              textConfirmation={Strings.common.thisActionIsIrreversible}
              textIcon={Strings.lightShows.deleteLightShow}
            />
          </StyledContainerItems>

          <StyledContainerFooterSideBar>
            <button
              type="button"
              className="btn-cancel"
              onClick={() => {
                setOpenSideBar(false);
                setSelectedLightShows([]);
              }}
            >
              {Strings.common.cancel}
            </button>
          </StyledContainerFooterSideBar>
        </>
      )}
      <div />
    </>
  );
};
